// extracted by mini-css-extract-plugin
export default {"root":"Summary_root__PCczl","summary":"Summary_summary__-pxFJ"};